import { render, staticRenderFns } from "./sideFloatBar.vue?vue&type=template&id=60c5019a&scoped=true"
import script from "./sideFloatBar.vue?vue&type=script&lang=js"
export * from "./sideFloatBar.vue?vue&type=script&lang=js"
import style0 from "./sideFloatBar.vue?vue&type=style&index=0&id=60c5019a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c5019a",
  null
  
)

export default component.exports